import { render, staticRenderFns } from "./group-detail.vue?vue&type=template&id=b35a4e6e&scoped=true&"
import script from "./group-detail.vue?vue&type=script&lang=js&"
export * from "./group-detail.vue?vue&type=script&lang=js&"
import style0 from "./group-detail.vue?vue&type=style&index=0&id=b35a4e6e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35a4e6e",
  null
  
)

export default component.exports